import { parseToNumberOrNull } from 'src/utils/numbers/parteToNumberOrNull';

const formatPrice = (
  amount: string | number | null | undefined,
  options?: Intl.NumberFormatOptions,
  showCurrency?: boolean
): string => {
  const price = parseToNumberOrNull(amount);

  if (!price && typeof price !== 'number') {
    return 'N/A';
  }

  const formatter = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: options?.maximumFractionDigits ?? 2,
    maximumFractionDigits: 2,
    ...options,
  });

  return `${showCurrency ? options?.currency || 'MXN' : ''} ${formatter.format(
    price
  )}`;
};

export default formatPrice;
